import { render, staticRenderFns } from "./FicoDistractionsDriverPivot.vue?vue&type=template&id=f627ae86&"
import script from "./FicoDistractionsDriverPivot.vue?vue&type=script&lang=js&"
export * from "./FicoDistractionsDriverPivot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports